import React from "react";
import imagesCss from "../../../assets/styles/images/images.module.scss";
import { Header } from "semantic-ui-react";
import { CopyInstruction } from "./CopyInstruction";
import { Button } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { IMAGE_COPY_CODE_SUCCESS } from "../../../constants/imageConstants";

export const CopyCodeImages = ({ slug }) => {
  const dispatch = useDispatch();
  const generateImageHtml = () => {
    return `<img src="${process.env.REACT_APP_DOMAIN_URL}/image_generation/${slug}?keyword={{KEYWORD_VALUE}}" alt="Image" style="width: 100%; height: 100%;" />`;
  };

  const copyCode = () => {
    navigator.clipboard.writeText(generateImageHtml());
    dispatch({ type: IMAGE_COPY_CODE_SUCCESS });
  };

  return (
    <div className={imagesCss.copyCode}>
      <div className={imagesCss.copyCodeContainer}>
        <div className={imagesCss.copyCodeHeader}>
          <Header as="h3">Copy Code</Header>
          <CopyInstruction />
        </div>
        <div className={imagesCss.imageHtmlCode}>
          <textarea readOnly value={generateImageHtml()} rows={5}></textarea>
        </div>
        <Button className={imagesCss.copyCodeButton} onClick={copyCode}>
          Copy code
        </Button>
      </div>
    </div>
  );
};
